import React from 'react'
import { BaseErrorDisplay } from './BaseErrorDisplay'
import infoSvg from '../icons/blankslate-info-icon.svg'

export const DeleteUserError = () => (
  <BaseErrorDisplay
    title="There is a problem removing your account."
    subtitle="USER CLEANUP ERROR"
    description="There's a problem that has prevented cleaning up this account. Please try again later. If the issue persists, please contact your account administrator or reach out to your CJ Account Team for assistance. You can also get support at cj.com."
    imgSrc={infoSvg}
  />
)
